import styled from 'styled-components';

export const ToggleContainer = styled.div<{
  rightMargin: string;
  checked: boolean;
  compact: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  > div {
    display: flex;
    align-items: center;
    margin-right: ${(props): string => props.rightMargin && props.rightMargin};
  }
  > span {
    margin-right: ${(props): string => props.rightMargin && props.rightMargin};
  }
  ${(props): string => (props.compact ? 'flex-direction: column;' : '')}
`;

export const Description = styled.span<{
  compact: boolean;
}>`
  font-size: 1rem;
  ${(props): string => (props.compact ? 'font-size: 0.875rem;' : '')}
  color: ${(props): string =>
    props.compact ? props.theme.palette.text.muted : 'inherit'};

  margin-bottom: 2px;
  white-space: nowrap;
`;

export const ToggleBlock = styled.div`
  line-height: 26px;
`;

export const ToggleWrapper = styled.label`
  &&& {
    margin: 0 10px 0 10px;
  }

  .react-toggle {
    display: flex;
    align-items: center;
  }

  .react-toggle-track {
    width: 37px;
    height: 17px;
    background-color: #b3b3b3;
    border-radius: 8.5px;
  }

  .react-toggle-screenreader-only {
    display: none;
  }

  .react-toggle--checked .react-toggle-track {
    background-color: ${(props): string => props.theme.palette.primary.main};
  }

  .react-toggle:hover:not(.react-toggle--disabled) .react-toggle-track {
    background-color: ${(props): string => props.theme.palette.grey.normal};
  }

  .react-toggle--checked:hover:not(.react-toggle--disabled)
    .react-toggle-track {
    background-color: ${(props): string => props.theme.palette.primary.main};
  }

  .react-toggle-thumb {
    top: 1px;
    left: 1px;
    width: 15px;
    height: 15px;
    border: none;
  }

  .react-toggle--checked .react-toggle-thumb {
    left: 21px;
  }
`;

export const OffText = styled.span`
  font-size: 0.875rem;
  color: ${(props): string => props.theme.palette.text.muted};
`;

export const OnText = styled.span<{ checked: boolean }>`
  font-size: 0.875rem;
  color: ${(props): string =>
    props.checked
      ? props.theme.palette.primary.light
      : props.theme.palette.text.muted};
`;
